(ns kyber.core
  "Application entry point. Utilizes code splitting to load submodules."
  (:require [shadow.loader :as loader]
            [applied-science.js-interop :as j]
            [potpuri.core :as pot]
            [clojure.string :as str]
            [kyber.constants :as c]))

(defn- load-success
  [module-key]
  (js/console.log (str "Loaded " (name module-key))))

(defn- load-failure
  [module-key]
  (js/console.error (str "Failed to load " (name module-key))))

(defn- load-module [module-key]
  (-> module-key name loader/load
      (j/call :then
              (partial load-success module-key)
              (partial load-failure module-key))))

(defn- load-app-module
  [is-admin-app]
  (if is-admin-app
    (load-module :admin)
    (load-module :learner)))

;; Part of non-optimal workaround for redirect bug
;; https://github.com/Archemedx/kyber/issues/7156
(defn- set-initial-location! []
  (let [{:keys [hash host hostname href origin pathname port]}
        (-> js/window (j/get :location) j/lookup)]
    (reset! c/initial-location
            (pot/map-of hash host hostname href origin pathname port))))

(defn init
  []
  (set-initial-location!)
  (let [is-admin-app (-> js/window
                         (j/get-in [:location :pathname])
                         (str/starts-with? "/admin"))]
    (reset! c/app-name (if is-admin-app "admin" "learner"))
    (load-app-module is-admin-app)))
